module.exports = __webpack_public_path__ + "img/1_026.e8012d77.jpg";